import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { GlobalKeyEventProvider } from "./context/KeyEventContext";
import { GlobalMouseEventProvider } from "./context/MouseEventContext";
import PlatzRoutes from "./components/PlatzRoutes";
import { AuthProvider } from "./context/AuthContext";
import { WordContextProvider } from "./context/WordContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      networkMode: "always",
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
    mutations: { networkMode: "always" },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <WordContextProvider>
          <GlobalKeyEventProvider>
            <GlobalMouseEventProvider>
              <BrowserRouter>
                <PlatzRoutes />
              </BrowserRouter>
            </GlobalMouseEventProvider>
          </GlobalKeyEventProvider>
        </WordContextProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
